import type React from 'react';

import '../styles/login.css';
import { signOut } from '@/core/providers/AuthFirebaseProvider';
import { CenteredSpin } from './CenteredSpin';

export const LogoutView: React.FC = () => {
  signOut().then(() => {
    window.location.href = '/';
  });

  return <CenteredSpin />;
};
